import { RpcDefinitions, RpcEndpoint } from './server.js';
import { HttpMethod } from '../client/http-method.js';

export type HttpRpcDefinition<Rpc extends RpcDefinitions> = {
  [Prop in keyof Rpc]: HttpEndpoint<Rpc[Prop]>;
};

export type HttpSource =
  { type: 'body' } | { type: 'query' } | { type: 'path' } | { type: 'header' };

export interface HttpEndpoint<Rpc extends RpcEndpoint> {
  method: HttpMethod;
  path: string;
  mapping: { [Prop in keyof Rpc['input']['_output']]: HttpSource };
  openapi: Partial<{
    operationId: string;
    description: string;
    tags: string[];
  }>;
}

export function defineHttpRpc<
  Rpc extends RpcDefinitions,
  Http extends HttpRpcDefinition<Rpc>,
>(rpc: Rpc, http: Http): HttpRpcDefinition<Rpc> {
  return http;
}
